import { PathologyPutParams } from "./pathology";

export interface UploadParams {
  uuid: string;
  sequences: string[];
}

export interface UploadState {
  uploadData: UploadParams | null;
  loading: boolean;
  error: null | string;
  success: boolean;
}

export interface PutDataParams {
  uuid: string;
  sequencesData: PathologyPutParams[];
}

export enum UploadActionTypes {
  UPLOAD_FILE = "UPLOAD_FILE",
  UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS",
  UPLOAD_FILE_ERROR = "UPLOAD_FILE_ERROR",

  REMOVE_SEQUENCE = "REMOVE_SEQUENCE",

  PUT_UPLOAD_DATA = "PUT_UPLOAD_DATA",
  PUT_UPLOAD_DATA_SUCCESS = "PUT_UPLOAD_DATA_SUCCESS",
  PUT_UPLOAD_DATA_ERROR = "PUT_UPLOAD_DATA_ERROR",
}

interface UploadFileAction {
  type: UploadActionTypes.UPLOAD_FILE;
}

interface UploadFileSuccessAction {
  type: UploadActionTypes.UPLOAD_FILE_SUCCESS;
  payload: UploadParams;
}

interface UploadFileErrorAction {
  type: UploadActionTypes.UPLOAD_FILE_ERROR;
  payload: string;
}

interface RemoveSequenceAction {
  type: UploadActionTypes.REMOVE_SEQUENCE;
  payload: UploadParams;
}

interface PutUploadDataAction {
  type: UploadActionTypes.PUT_UPLOAD_DATA;
}

interface PutUploadDataSuccessAction {
  type: UploadActionTypes.PUT_UPLOAD_DATA_SUCCESS;
}

interface PutUploadDataErrorAction {
  type: UploadActionTypes.PUT_UPLOAD_DATA_ERROR;
  payload: string;
}

export type uploadAction =
  | UploadFileAction
  | UploadFileSuccessAction
  | UploadFileErrorAction
  | RemoveSequenceAction
  | PutUploadDataAction
  | PutUploadDataSuccessAction
  | PutUploadDataErrorAction;
